export default "__VITE_ASSET__DPzQpeiB__"